import PaginationUI from "../atoms/PaginationUI";
import ColumnDate from "../molecules/ColumnDate";
import ColumnLabels from "../molecules/ColumnLabels";
import ColumnText from "../molecules/ColumnText";
import ColumnPersonInformationAvatar from "../molecules/ColumnPersonInformationAvatar";
// import { formatToDDMMYYYY } from "@/shared/utils/utils"; // No se usa directamente aquí
import LoadTable from "./LoadTable";
import { useState, useMemo } from "react"; // Agregado useMemo

export type userTicketsProps = {
  id: number;
  name: string;
  avatar: string;
  email: string;
};

export type TicketsPageProps = {
  created_at: string;
  updated_at: string;
  date_end: string;
  id: number;
  token: string;
  client: userTicketsProps;
  support: userTicketsProps;
  branch: {
    id: number;
    branch: string;
  };
  incidence: string;
  responsible: string;
  date: string;
  status: string;
  created: string;
  result: string;
};

export type TableListTicketsProps = {
  tickets: TicketsPageProps[];
  openModal: (ticket: TicketsPageProps) => void;
  loading: boolean;
};

const ITEMS_PER_PAGE = 10; // Define cuántos elementos quieres por página

const TableListTickets: React.FC<TableListTicketsProps> = ({
  tickets,
  loading,
  openModal,
}) => {
  const [currentPage, setCurrentPage] = useState(1); // Corregido el typo: curretnPage -> currentPage

  const translateState = (state: string) => {
    if (state === "No Read") return "No leído";
    if (state === "Finished") return "Terminado";
    if (state === "Read") return "Leído";
    if (state === "Technical Support") return "Soporte técnico";
    return state;
  };

  // --- Lógica de paginación corregida ---
  const totalResults = tickets?.length || 0;
  const totalPages = Math.ceil(totalResults / ITEMS_PER_PAGE);

  // Usamos useMemo para evitar recalcular esto en cada renderizado si tickets o currentPage no cambian
  const paginatedTickets = useMemo(() => {
    if (!tickets || tickets.length === 0) {
      return [];
    }
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const endIndex = startIndex + ITEMS_PER_PAGE;
    return tickets.slice(startIndex, endIndex);
  }, [tickets, currentPage]);
  // --- Fin de la lógica de paginación corregida ---

  if (loading) {
    return <LoadTable />;
  }

  // Resetea a la página 1 si la página actual queda fuera de rango (por ejemplo, si los datos cambian)
  if (totalResults > 0 && currentPage > totalPages) {
    setCurrentPage(1); // O podrías setear a totalPages si prefieres
  }

  return (
    <div className="px-4 sm:px-6 lg:px-0">
      <div className="mt-2 flow-root">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <div className="max-h-svh overflow-y-auto">
              <table className="min-w-full table-fixed divide-y divide-gray-300">
                <thead>
                  <tr>
                    <th className="w-1/6 sticky top-0 z-10 border-b border-gray-300 bg-white bg-opacity-75 py-3.5 pl-4 text-left text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter sm:pl-6 lg:pl-8">
                      Usuario
                    </th>
                    <th className="w-1/6 sticky top-0 z-10 border-b border-gray-300 bg-white bg-opacity-75 px-3 text-left text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter">
                      Incidencia (Token)
                    </th>
                    <th className="w-1/6 sticky top-0 z-10 border-b border-gray-300 bg-white bg-opacity-75 px-3 text-left text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter">
                      Responsable (Soporte)
                    </th>
                    <th className="w-1/6 sticky top-0 z-10 border-b border-gray-300 bg-white bg-opacity-75 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter">
                      Estado
                    </th>
                    <th className="w-1/6 sticky top-0 z-10 border-b border-gray-300 bg-white bg-opacity-75 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter">
                      Creado
                    </th>
                    <th className="w-1/6 sticky top-0 z-10 border-b border-gray-300 bg-white bg-opacity-75 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter">
                      Resuelto
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  {paginatedTickets.length > 0 ? (
                    paginatedTickets.map((ticket) => {
                      return (
                        <tr
                          className="cursor-pointer hover:bg-gray-50" // Pequeña mejora de UX
                          key={ticket?.id || ticket?.client?.email}
                          onClick={() => openModal(ticket)}
                        >
                          <ColumnPersonInformationAvatar
                            open_user={true}
                            id={ticket?.client?.id}
                            name={ticket?.client?.name}
                            image={
                              ticket?.client?.avatar ??
                              "https://dash.fitmewise.com/uploads/users/profile.png"
                            }
                            email={ticket?.client?.email}
                          />
                          <ColumnText title={ticket?.token} />
                          <ColumnText title={ticket?.support?.name} />
                          <ColumnLabels
                            labels={[translateState(ticket?.status)]}
                          />
                          <ColumnDate
                            date={ticket?.created_at?.split("T")[0]}
                          />
                          <ColumnDate
                            date={
                              ticket?.date_end
                                ? ticket.date_end.split("T")[0]
                                : undefined
                            }
                          />
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td
                        colSpan={6}
                        className="py-4 text-center text-gray-500"
                      >
                        No hay tickets para mostrar.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <PaginationUI
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={(page) => {
            setCurrentPage(page);
          }}
          pageSize={ITEMS_PER_PAGE} // Usar el valor constante
          totalResults={totalResults}
        />
      </div>
    </div>
  );
};

export default TableListTickets;
